export default __webpack_public_path__ + "static/media/nft7.a4bfacdf.jpg";